import { useEffect } from 'react';
import { useRouter } from 'next/router';
import useUser, { getPendingWordpressConnect } from '../lib/useUser';
import Loading from '../components/common/Loading';
import InternalLayout from '../components/layouts/internal/InternalLayout';
import * as onboardingWizard from '../lib/onboardingWizard';

function Index() {
  const { user, workspace } = useUser({ redirectTo: '/login' });
  const router = useRouter();

  useEffect(() => {
    if(user && onboardingWizard.isWorkspaceLoaded(workspace) && router.isReady) {
      const { redirect } = router.query;
      const recentWorkspaceId = workspace.id;
      const pendingWordpressConnect = getPendingWordpressConnect();

      if(pendingWordpressConnect) {
        return router.push(pendingWordpressConnect);
      }

      if(redirect) {
        return router.push(`/${recentWorkspaceId}${redirect}`);
      }

      if(onboardingWizard.shouldLandInWizard(user, workspace)) {
        return router.push(`/${recentWorkspaceId}/get-started`);
      }

      return router.push(`/${recentWorkspaceId}/testimonials`);
    }
  }, [user, workspace, router.isReady]);
  return <Loading />;
}

Index.Layout = InternalLayout;
export default Index;
